// extracted by mini-css-extract-plugin
module.exports = {"selected-list":"TagsList-module__selected-list___XNk25","selectedList":"TagsList-module__selected-list___XNk25"};